import {useGetRcnDataQuery} from "../api/get_rcn_data_api";
import {RoomsFilter} from "../constants/rcn_rooms_filter";
import {RcnPriceStatsGrain} from "../types/IRcnPriceStats";
import {IRcnStats} from "../types/IRcnStats";
import {RcnPriceStatsQuery, RcnStatsTarget} from "../types/RcnPriceStatsQuery";
import {getPublishableRcnPoint} from "../utils/get_publishable_rcn_point";
import {getRcnPeriodQuery} from "../utils/get_rcn_params";

export type {IRcnStats} from "../types/IRcnStats";

/**
 * The target's point for one given period of one grain - the counterpart of useRcnLatestStats for a region
 * that is compared against another point, so both read the same month, quarter or year. Idle (no point, not
 * loading) until `periodStart` and `grain` are known.
 */
export const useRcnPeriodStats = (
    target: RcnStatsTarget | null | undefined,
    rooms: RoomsFilter,
    unit: RcnPriceStatsQuery["unit"],
    periodStart: string | null,
    grain: RcnPriceStatsGrain | null
): IRcnStats => {
    const {currentData, isLoading, isFetching, isError} = useGetRcnDataQuery(getRcnPeriodQuery(target ?? 0, rooms, unit, periodStart ?? "", grain ?? "month"), {
        skip: !target || !periodStart || !grain
    });

    return {
        point: getPublishableRcnPoint(currentData),
        isLoading: isLoading || isFetching,
        isError
    };
};
import {useGetRcnDataQuery} from "../api/get_rcn_data_api";
import {RoomsFilter} from "../constants/rcn_rooms_filter";
import {RcnPriceStatsGrain} from "../types/IRcnPriceStats";
import {IRcnStats} from "../types/IRcnStats";
import {RcnPriceStatsQuery, RcnStatsTarget} from "../types/RcnPriceStatsQuery";
import {getPublishableRcnPoint} from "../utils/get_publishable_rcn_point";
import {getRcnPeriodQuery} from "../utils/get_rcn_params";

export type {IRcnStats} from "../types/IRcnStats";

/**
 * The target's point for one given period of one grain - the counterpart of useRcnLatestStats for a region
 * that is compared against another point, so both read the same month, quarter or year. Idle (no point, not
 * loading) until `periodStart` and `grain` are known.
 */
export const useRcnPeriodStats = (
    target: RcnStatsTarget | null | undefined,
    rooms: RoomsFilter,
    unit: RcnPriceStatsQuery["unit"],
    periodStart: string | null,
    grain: RcnPriceStatsGrain | null
): IRcnStats => {
    const {currentData, isLoading, isFetching, isError} = useGetRcnDataQuery(getRcnPeriodQuery(target ?? 0, rooms, unit, periodStart ?? "", grain ?? "month"), {
        skip: !target || !periodStart || !grain
    });

    return {
        point: getPublishableRcnPoint(currentData),
        isLoading: isLoading || isFetching,
        isError
    };
};
